<div class="sig-card">
  <div
    class="sig-loading"
    *ngIf="isLoading"
    role="status"
    aria-label="Loading signals"
  >
    <ngx-skeleton-loader
      count="5"
      [theme]="{ height: '34px', 'margin-bottom': '10px' }"
    ></ngx-skeleton-loader>
  </div>

  <ng-container *ngIf="!isLoading">
    <div class="sig-state" *ngIf="hasError" role="status">
      <p>Signals could not be loaded.</p>
      <button type="button" class="sig-btn" (click)="loadSegments()">
        Try again
      </button>
    </div>

    <div class="sig-state" *ngIf="!hasError && !stage">
      <p>No segments are set up for this store yet.</p>
    </div>

    <ng-container *ngIf="!hasError && stage">
      <div class="sig-head">
        <span class="sig-head-name">{{ stage.name }}</span>
        <span class="sig-head-meta" *ngIf="stage.sessions">
          {{ stage.sessions | number }} sessions
        </span>
        <span class="sig-head-meta sig-collecting" *ngIf="!stage.sessions">
          <span class="sig-collecting-dot"></span>
          Collecting data
        </span>
      </div>

      <ul class="sig-segments" [style.--sig-tint]="stage.tint">
        <li class="sig-segment" *ngFor="let segment of stage.segments">
          <div class="sig-segment-head">
            <span class="sig-segment-name">
              <span
                class="sig-segment-state"
                [class.is-live]="segment.live"
                [matTooltip]="segment.live ? 'Live' : 'Not activated'"
                matTooltipPosition="above"
              ></span>
              {{ segment.name }}
            </span>
            <span class="sig-segment-share">
              {{ stage.sessions ? (segment.share | number: "1.0-1") + "%" : "—" }}
            </span>
          </div>
          <div class="sig-segment-track">
            <div class="sig-segment-bar" [style.width.%]="segment.share"></div>
          </div>
        </li>
      </ul>

      <div class="sig-footer">
        <button type="button" class="sig-btn" (click)="view()">
          Open Signals
        </button>
        <span class="sig-footer-note">
          {{ stage.liveCount }} of {{ stage.segmentCount }} segments live
        </span>
      </div>
    </ng-container>
  </ng-container>
</div>
